import { ApiSuccessResponse, GraphBody } from "../../@types";
import { apiSlice } from "../../app/api/apiSlice";
import {
  FuelLog,
  FuelLogExportBody,
  FuelLogGraphData,
  FuelLogHistorySearchRequest,
  FuelLogSearchRequest,
  FuelLogSearchResponse,
  FuelLogStats,
} from "./@types";

export const fuelLogApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFuelLogs: builder.mutation<
      ApiSuccessResponse<FuelLogSearchResponse>,
      FuelLogSearchRequest
    >({
      query: (data) => ({
        url: "/v1/fuellog/search",
        method: "POST",
        body: { ...data },
      }),
    }),
    getFuelLogHistory: builder.mutation<
      ApiSuccessResponse<FuelLogSearchResponse>,
      FuelLogHistorySearchRequest
    >({
      query: (data) => ({
        url: "/v1/fuellog/history",
        method: "POST",
        body: { ...data },
      }),
    }),
    getFuelLogStats: builder.query<ApiSuccessResponse<FuelLogStats>, void>({
      query: () => ({
        url: "/v1/fuellog/stat",
        method: "GET",
      }),
    }),
    getFuelLogById: builder.query<ApiSuccessResponse<FuelLog>, string>({
      query: (id) => ({
        url: `/v1/fuelLog/getfuelLog/${id}`,
        method: "GET",
      }),
    }),
    getFuelLogGraphData: builder.query<
      ApiSuccessResponse<FuelLogGraphData>,
      GraphBody
    >({
      query: (id) => ({
        url: `/v1/fuellog/graph`,
        method: "GET",
      }),
    }),
    exportFuelLogs: builder.mutation<Blob, FuelLogExportBody>({
      query: (data) => ({
        url: "/v1/fuellog/export",
        method: "POST",
        body: data,
        responseHandler: async (response) => {
          return await response.blob();
        },
      }),
    }),
  }),
});

export const {
  useGetFuelLogsMutation,
  useGetFuelLogHistoryMutation,
  useGetFuelLogStatsQuery,
  useGetFuelLogByIdQuery,
  useGetFuelLogGraphDataQuery,
  useExportFuelLogsMutation,
} = fuelLogApiSlice;
